import ConciergePreview from '@/pages/ConciergePreview'
import CloseIcon from '@mui/icons-material/Close'
import { AppBar, Backdrop, Box, IconButton, Toolbar } from '@mui/material'
import { useState } from 'react'
import EmailLinkForm from '../components/EmailLinkForm'
import { useDrawer } from '../hooks/useDrawer'
import { headerHeight } from '../store/constant'
import Header from './Header'
import MainContent from './MainContent'
import Sidebar from './Sidebar'

export default function PreviewLayout() {
  const [showLoginOverlay, setShowLoginOverlay] = useState(false)
  const { drawerOpen } = useDrawer()

  const overlayWidth = drawerOpen ? '100%' : '78px'

  function handleOverlayClick() {
    setShowLoginOverlay(true)
  }

  return (
    <Box sx={{ display: 'flex', backgroundColor: 'grey.200', height: '100vh' }}>
      <AppBar
        enableColorOnDark
        position='fixed'
        color='inherit'
        elevation={0}
        sx={{ bgcolor: 'grey.200' }}
      >
        <Toolbar sx={{ p: 2, height: headerHeight }} className='toolbar'>
          <Header />
        </Toolbar>
      </AppBar>

      <Box className='sidebar' sx={{ position: 'relative' }}>
        <Box
          className='overlay'
          onClick={handleOverlayClick}
          sx={{
            position: 'absolute',
            top: headerHeight,
            left: 0,
            width: overlayWidth,
            height: '50%',
            zIndex: 10000,
            backgroundColor: 'transparent',
            cursor: 'pointer',
          }}
        />

        <Sidebar />
      </Box>

      <MainContent drawerOpen={drawerOpen}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            height: `calc(100vh - ${headerHeight}px)`,
            top: headerHeight,
            overflow: 'auto',
          }}
        >
          <ConciergePreview />
        </Box>
      </MainContent>
      <Backdrop
        transitionDuration={300}
        open={showLoginOverlay}
        onClick={() => setShowLoginOverlay(false)}
        sx={{
          color: '#fff',
          zIndex: (theme) => theme.zIndex.drawer + 1,
          backgroundColor: 'rgba(0, 0, 0, 0.45)',
        }}
      >
        <Box
          onClick={(e) => e.stopPropagation()}
          sx={{
            position: 'relative',
            bgcolor: 'background.paper',
            color: 'text.primary',
            p: 4,
            borderRadius: 2,
            width: '400px',
            maxWidth: 400,
            minHeight: 200,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <IconButton
            onClick={() => setShowLoginOverlay(false)}
            sx={{
              position: 'absolute',
              top: 8,
              right: 8,
              color: 'grey.500',
            }}
          >
            <CloseIcon />
          </IconButton>
          <EmailLinkForm isOpen={showLoginOverlay} emailAutosentTo='' />
        </Box>
      </Backdrop>
    </Box>
  )
}
